
export const SET_IKA_MAP_DATA = 'SET_IKA_MAP_DATA';
export const SET_IKA_MAP_DATA_LOADING = 'SET_IKA_MAP_DATA_LOADING';

export const SET_INPUT_SUGGESTIONS = 'SET_INPUT_SUGGESTIONS';

export const SET_IKA_MAP_COUNTRIES = 'SET_IKA_MAP_COUNTRIES';
export const SET_IKA_MAP_COUNTRIES_LOADING = 'SET_IKA_MAP_COUNTRIES_LOADING';

export const SET_IKA_ERROR = 'SET_IKA_ERROR';

export const SET_COST_CATEGORIES_DATA = 'SET_COST_CATEGORIES_DATA';
export const SET_COST_CATEGORIES_DATA_LOADING = 'SET_COST_CATEGORIES_DATA_LOADING';

